import { Exclude, Transform, Type } from 'class-transformer';

import { booleanTransform } from '../utils/helper';
import { Actor } from './actor.model';
import { Doctor } from './doctor.model';

export class Patient {
	id?: number;
	doctorid?: number;
	doctorname?: string;
	hostedlocation?: string;
	invoiceto?: number;
	contact?: string;
	rifdoorbell?: string;
	floor?: number;
	@Transform(booleanTransform)
	lift?: number;
	residenceplace?: string;
	deambulation?: number; // 0 > nulla, 1 > scarsa, 2 > buona
	cancomunicate?: number; // 0 > nulla, 1 > scarsa, 2 > buona
	weight?: string;
	@Transform(booleanTransform)
	psychiatric?: boolean;
	sightissue?: number; // 0 > cecità totale, 1 > sì, 2 > no
	hearingissue?: number; // 0 > sordità totale, 1 > sì, 2 > no
	@Transform(booleanTransform)
	wheelchair?: boolean;
	@Transform(booleanTransform)
	gurney?: boolean;
	disabilitypct?: number;
	@Transform(booleanTransform)
	personalassistant?: boolean;
	assistantnote?: string;
	@Transform(booleanTransform)
	ztl?: boolean;
	transportablewith?: number;

	@Exclude({ toPlainOnly: true })
	@Type(() => Doctor)
	seconddriver?: Doctor;

	@Exclude({ toPlainOnly: true })
	@Type(() => Actor)
	doctor?: Actor;

	@Exclude({ toPlainOnly: true })
	@Type(() => Actor)
	payer?: Actor;
}

export function patient(){
	return Patient;
}